import { motion } from "framer-motion";
import { Mail, ArrowUpRight } from "lucide-react";

const Contact = () => (
  <section id="iletisim" className="px-6 lg:px-16 py-28 bg-[#0F0E17] border-t border-white/[0.06]">
    <div className="max-w-7xl mx-auto text-center">
      <motion.span
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="font-code text-xs text-[#10B981] tracking-[0.3em]"
      >
        İLETİŞİM
      </motion.span>

      <motion.h2
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.1 }}
        className="font-display font-bold text-4xl sm:text-5xl mt-5 tracking-tight"
      >
        Aklında bir proje mi var<span className="text-[#10B981]">?</span>
        <br />
        Konuşalım<span className="text-[#10B981]">.</span>
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="text-[#9CA3AF] mt-6 max-w-md mx-auto leading-relaxed"
      >
        Formu doldurabilir ya da doğrudan e-posta gönderebilirsin — iki şekilde de 24 saat içinde dönüş yaparım.
      </motion.p>

      <motion.a
        href="mailto:beforanet@gmail.com"
        data-testid="contact-email-button"
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="group inline-flex items-center gap-3 mt-12 border border-white/15 hover:border-[#10B981]/60 rounded-full px-8 py-4 transition-colors duration-300"
      >
        <Mail size={18} className="text-[#10B981]" />
        <span className="font-code text-lg text-white group-hover:text-[#10B981] transition-colors duration-300">
          beforanet@gmail.com
        </span>
        <ArrowUpRight size={18} className="text-[#6B7280] transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-[#10B981]" />
      </motion.a>
    </div>
  </section>
);

export default Contact;
